export default __webpack_public_path__ + "static/media/frame_th_sp-landscape.c1a43ab5.png";